module.exports = {
      id: "bondhushava-usage",
      viewBox: "0 0 225 61",
      url: "/" + "sprite-819208feb9a4c8de23db7726a2e05315.svg#bondhushava",
      toString: function () {
        return this.url;
      }
    }